import React from 'react';
import Jiraintercomdescription from './jiraintercomdescription';
import {  FluxText } from '@meltwater/flux-web-components-react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Grid } from '@mui/material';
const jiraIntercom = ({ intercom }) => {

  const displayintercom = (intercomitem) => {
    let retval;
    retval = (<Card >
      <CardContent>
        <div slot="header">
          <FluxText appearance="body-heavy" as="div" nowrap >
            {intercomitem.updated} {intercomitem.author.displayName}
          </FluxText>
          <FluxText appearance="body2" as="div" nowrap >{intercomitem.updateAuthor.timeZone}</FluxText>
        </div>

        <div style={{width:'100%'}}  slot="body">
          <Jiraintercomdescription data={intercomitem.body} />
        </div>
      </CardContent>
    </Card >)


    return retval
  }

  return (
   
    <Grid container spacing={1} >
          
      {intercom && intercom.map((intercomitem,index) => (
        <Grid key={index} item xs={12}  >
     
            {displayintercom(intercomitem)}
 
        </Grid>
      ))}
      </Grid>
     

   
  );
};

export default jiraIntercom;
